import VueElementLoading from 'vue-element-loading';
import { BasicSelect, MultiSelect } from 'vue-search-select'
import Pagination from './../../../../shared/components/pagination'
import CustomExpandableTable from '../../../../shared/components/customExpandableTable'
import Loader from '../../../../shared/components/loader'
import Multiselect from 'vue-multiselect'
import { Validator } from 'vee-validate';
import CryptoJS from 'crypto-js';
import Treeselect from '@riophae/vue-treeselect';
import CargoBookingServices from './../../../../cargobooking/services/cargobooking.service'
import MasterService from './../../../services/masterdata.service'
import { version } from 'chai';
import XLSX from 'xlsx';
import Util from './../../../../shared/util/util';


export default {
  name: 'viewratetemplate',
  props: ['dataForView' ,'businesstype','callfrom'],
  components: {
    VueElementLoading,
    Pagination,
    BasicSelect,
    Loader,
    CustomExpandableTable,
    Multiselect,
    Validator,
    Treeselect,

  },
  data: function () {
    return {
      isLoading: false,
      selectAll: false,
      records: [],
      allOpenRows: [],
      perPage: 10,
      ShowAirlineCharges : false, 
      versionList : [],
      selectedVersion : null,
      airlineList: [],
      selectedIndex: null,
      charges: [
        { name: "Base Freight Template" },
        { name: "Origin Terminal Template" },
        { name: "Destination Terminal Templates" },
        { name: "Other Charge Template" },
        { name: "Origin Operator Template" },
        { name: "Destination Operator Template"},
      ] ,
      selectedAirlineStatus : 0,
      selectedEffectiveFrom : null,
      rateid : null,
      todaysDate :Util.getCurrentDateOnly(),
      datechanged :false,
      versionModal : false,
    }
  },
  async mounted() {
    if (!this.callfrom) {
      await this.GetActiveAirlinesForCategory()
    }else{
      this.selectedAirlineStatus = this.dataForView.status
      this.selectedEffectiveFrom = this.dataForView.effectivefrom
      this.rateid = this.dataForView.id
      this.airlineList = [{
        id : this.dataForView.airline,
        name : this.dataForView.airlinename
      }]
    }
    
  },
  computed:{
  },
  methods: {
    async GetActiveAirlinesForCategory() {
      try {
        this.isLoading = true
        let inputpayload = {
          category : this.dataForView.id,
          businesstype : this.businesstype
        }
        let result = await MasterService.GetActiveAirlinesForCategory(inputpayload)
        if (result.data.code == 200) {
          // result.data.data.resultairlinename.forEach(el => {
          //   this.airlineList.push({
          //     'id': el.id,
          //     'name': el.airlinename,
          //     'expanded' : false
          //   })
          // })
          this.airlineList = result.data.data
        }
        else {
          this.airlineList = []
          this.$alertify.error(result.data.message)
        }
        this.isLoading = false
      } catch (err) {
        this.isLoading = false
      }
    },
     async getAirlinesRateDetails() {
      try {
        this.isLoading = true
        let inputpayload = {}
        inputpayload.businesstype = this.businesstype
        if (this.callfrom) {
          inputpayload.rateid=this.dataForView.id
          inputpayload.category = this.dataForView.category
        }else{
          inputpayload.category = this.dataForView.id
        }
          inputpayload.airline = this.airlineList[this.selectedIndex].id
        let result = await MasterService.getAirlineRates(inputpayload)
        this.isLoading = false
        if(result.data.code == 200){
          // this.totalCount = result.data.data.count;
       this.selectedAirlineStatus = result.data.data.status
       this.selectedEffectiveFrom = result.data.data.effectivefrom
       this.rateid = result.data.data.id

      }else{
        this.selectedAirlineStatus  = 0
        this.selectedEffectiveFrom = null
      }
      } catch (err) {
        this.isLoading = false
      }
    },
    async selectItem(index) {
      this.datechanged = false;
      // this.airlineList[index].expanded = !this.airlineList[index].expanded;
      if (index == this.selectedIndex) {
        this.selectedIndex = null
      }else{
        this.selectedIndex = index;
        await this.getAirlinesRateDetails()
      }
     
    },
    action(event){
      if (event == "active") {
        this.$confirm("Are you sure to make Active/Inactive?", "", "question").then(() => {
          // this.activeAction(event);
           this.UpdateAirlineMasterData("active")
        }).catch((err) => {
          console.log(err)
        });
      } else if (event == "inactive") {
        this.$confirm("Are you sure to make Active/Inactive?", "", "question").then(() => {
          // this.activeAction(event);
          this.UpdateAirlineMasterData("inactive")
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    async DownloadCharges(chargeType){
      try {
        this.isLoading = true
        let inputpayload = {}
        inputpayload.rateid = this.rateid
        inputpayload.chargeType = chargeType
        let result = await MasterService.downloadAirlineRates(inputpayload)
        this.isLoading = false
        if(result.data.code == 200){
          const data = XLSX.utils.json_to_sheet(result.data.data);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, data, 'data')
          XLSX.writeFile(wb,chargeType+'.xlsx');
        }else{
          this.$alert("No booking records to download", "Booking Data", "error");
        }
      //     // this.totalCount = result.data.data.count;
      // //  this.selectedAirlineStatus = result.data.data.status
      // //  this.selectedEffectiveFrom = result.data.data.effectivefrom
      //   }
      } catch (err) {
        this.isLoading = false
      }
    },
    async UpdateAirlineMasterData(status){
      try {
        this.isLoading = true
        let inputpayload = {}
        inputpayload.id = this.rateid
        let isvalidDate=true
        if (status && status == "active") {
          inputpayload.status = 0;
        }
        else if (status && status == "inactive") {
          inputpayload.status = 1;
        }
        inputpayload.id = this.rateid
        if (this.datechanged) {
          try {
            let payload = {}
            if (this.dataForView.category) {
              payload.category = parseInt(this.dataForView.category);
            }
            if (this.dataForView.airline) {
              payload.airline = this.dataForView.airline;
            }
            if (this.dataForView.effectivefrom) {
              payload.effectivefrom = this.selectedEffectiveFrom
            }
            if (this.dataForView.businesstype) {
              payload.businesstype = this.dataForView.businesstype
            }
            let resultforDatevalidation = await MasterService.checkAirlineDate(payload)
            if (resultforDatevalidation.data.code == 200) {
              this.isLoading = false
              isvalidDate = false
              this.$alert(resultforDatevalidation.data.message, "", "error");
            }

            inputpayload.effectivefrom = this.selectedEffectiveFrom
          }
          catch (err) {
            throw err
          }
        }
        if (isvalidDate) {
          let result = await MasterService.UpdateAirlineMasterData(inputpayload)
          this.isLoading = false
          if (result.data.code == 200) {
            if (status && status == "active") {
              this.selectedAirlineStatus = 0;
            }
            else if (status && status == "inactive") {
              this.selectedAirlineStatus = 1;
            }
            await this.$emit("updateDate")
            this.$alert("Effective From date updated successfully", "", "success");
          } else {
            this.$alert(result.data.message, "", "error");
          }
        }     
      //     // this.totalCount = result.data.data.count;
      // //  this.selectedAirlineStatus = result.data.data.status
      // //  this.selectedEffectiveFrom = result.data.data.effectivefrom
      //   }
      } catch (err) {
        this.isLoading = false
      }
    }
    


  }
}



// WEBPACK FOOTER //
// ./src/modules/masterdata/views/AirWalletTemplate/viewairratetemplate/viewairratetemplate.component.js